export default "__VITE_ASSET__szwAUIrG__"